import React from "react";
import Tabs from "./Tabs";
import { useState, useEffect } from "react";
import Posts from "./Posts";
import "./Social.css";
import ActivityLog from "./ActivityLog";
import { getRecentPosts } from "../../redux/slices/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import Calendar from "./Calendar";
import Approvals from "./Approvals";
import Accounts from "./Accounts";
import Navigation from "./Navigation";
import RightSidebar from "../../components/common/RightSidebar";
import PostPreview from "./PostPreview";
import useAuth from "../../hooks/useAuth";
import {
  tableAccountsData,
  TableHeadersAccounts,
} from "./socialCalendarConstants";

const SocialCalendarLayout = () => {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [activeTab, setActiveTab] = useState("RecentPosts");
  const [clickedEvent, setClickedEvent] = useState(null);
  const [query, setQuery] = useState("");
  const [accountsData, setAccountsData] = useState(tableAccountsData || []);
  const dispatch = useDispatch();
  const { recentPosts, upcomingPosts, getAllPost } = useSelector(
    (state) => state.api
  );
  const [activityLogData, setActivityLogData] = useState(getAllPost || []);

  const [recentPostsData, setRecentPostsData] = useState(recentPosts || []);
  const [upcomingPostsData, setUpcomingPostsData] = useState(
    upcomingPosts || []
  );

  useEffect(() => {
    if (activeTab === "RecentPosts") {
      dispatch(getRecentPosts());
    }
    setQuery("");
  }, [activeTab]);

  useEffect(() => {
    const regex = new RegExp(query, "i");

    setAccountsData(
      query
        ? tableAccountsData.filter(
            (item) =>
              regex.test(item.franchiseName ?? "") ||
              regex.test(item.outletCode ?? "") ||
              regex.test(item.outletName ?? "")
          )
        : tableAccountsData
    );

    setActivityLogData(
      query
        ? getAllPost.filter((item) => {
            const platformStr =
              item.platforms?.map((p) => p.platformName).join(", ") ?? "";
            const outletStr =
              item.accounts?.map((a) => a.accountName).join(", ") ?? "";

            return regex.test(platformStr) || regex.test(outletStr);
          })
        : getAllPost
    );

    setRecentPostsData(
      query
        ? recentPosts.filter((item) => {
            const outletStr =
              item.accounts?.map((a) => a.accountName).join(", ") ?? "";
            return regex.test(outletStr) || regex.test(item.caption);
          })
        : recentPosts
    );
    setUpcomingPostsData(
      query
        ? upcomingPosts.filter((item) => {
            const outletStr =
              item.accounts?.map((a) => a.accountName).join(", ") ?? "";
            return regex.test(outletStr) || regex.test(item.caption);
          })
        : upcomingPosts
    );
  }, [query, getAllPost, recentPosts, upcomingPosts]);
  const getType = (file) => {
    if (file instanceof Blob || file instanceof File) {
      return file.type.startsWith("image") ? "image" : "video";
    }

    if (typeof file === "string") {
      const lowerUrl = file.toLowerCase();
      if (
        lowerUrl.endsWith(".mp4") ||
        lowerUrl.endsWith(".webm") ||
        lowerUrl.endsWith(".mov")
      ) {
        return "video";
      }
      if (
        lowerUrl.endsWith(".png") ||
        lowerUrl.endsWith(".jpg") ||
        lowerUrl.endsWith(".jpeg") ||
        lowerUrl.endsWith(".gif") ||
        lowerUrl.endsWith(".webp")
      ) {
        return "image";
      }
    }

    return "image"; // default fallback
  };
  return (
    <div className="flex  flex-col">
      <RightSidebar
        isOpen={openSidebar}
        onClose={() => setOpenSidebar(false)}
        title={"Post"}
        content={
          <PostPreview
            postContent={clickedEvent}
            showApproval={activeTab !== "Calendar"}
          />
        }
      />
      <Navigation
        activeTab={activeTab}
        setActiveTab={(v) => setActiveTab(v)}
        query={query}
        setQuery={setQuery}
        tableAccountsData={tableAccountsData}
      />
      <div className="text-xs">
        {activeTab === "RecentPosts" ? (
          <Posts
            recentPosts={recentPostsData}
            upcomingPosts={upcomingPostsData}
          />
        ) : activeTab === "Calendar" ? (
          <Calendar
            setOpenSidebar={() => setOpenSidebar(true)}
            setClickedEvent={setClickedEvent}
            getAllPost={getAllPost}
          />
        ) : activeTab === "Approvals" ? (
          <Approvals
            getType={getType}
            recentPosts={recentPosts}
            getAllPost={getAllPost}
          />
        ) : activeTab === "Accounts" ? (
          <Accounts
            tableAccountsData={accountsData}
            TableHeadersAccounts={TableHeadersAccounts}
          />
        ) : activeTab === "Activity Log" ? (
          <ActivityLog getAllPost={activityLogData} getType={getType} />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default SocialCalendarLayout;
